import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BounceComponent } from './bounce/bounce.component';
import { ControlMessageComponent } from './messages/control-messages.component';
import { ValidationMessageComponent } from './messages/validation-messages.component';
import { StepComponent } from './step/step.component';
import { ResultComponent } from './modal/result/result.component';
import { ConvenienceStepComponent } from './convenience-step/convenience-step.component';


@NgModule({
    imports: [ FormsModule, CommonModule ],
    declarations: [
        BounceComponent,
        ControlMessageComponent,
        ValidationMessageComponent,
        StepComponent,
        ResultComponent,
        ConvenienceStepComponent,
    ],
    exports: [
        ValidationMessageComponent,
        BounceComponent,
        ControlMessageComponent,
        StepComponent,
        ResultComponent,
        ConvenienceStepComponent
    ],
    providers: [],
})
export class SharedComponentModule { }
